import React, { createContext, useContext, useState } from 'react';

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [pendingOperations, setPendingOperations] = useState(0);

  const showLoader = () => {
    setLoading(true);
  };

  const hideLoader = () => {
    setLoading(false);
  };

  const beginLoading = () => {
    setPendingOperations((count) => count + 1);
    let finished = false;
    return () => {
      if (finished) return;
      finished = true;
      setPendingOperations((count) => count - 1);
    };
  };

  return <LoaderContext.Provider value={{ loading: loading || pendingOperations > 0, showLoader, hideLoader, beginLoading }}>{children}</LoaderContext.Provider>;
};

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('A useLoader csak egy LoaderProvider-en belül használható!');
  }
  return context;
};
